import { render } from "./requests-table.vue?vue&type=template&id=4ac23606&scoped=true"
import script from "./requests-table.vue?vue&type=script&lang=js"
export * from "./requests-table.vue?vue&type=script&lang=js"

import "./requests-table.vue?vue&type=style&index=0&id=4ac23606&lang=scss&scoped=true"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac23606"]])

export default __exports__